// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"98":"24211e5d","787":"7a3944f0"}[chunkId] + ".chunk.js";
};